/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_StorageInputs */

const en_val_storage = /** @type {(inputs: Val_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage`)
};

const es_val_storage = /** @type {(inputs: Val_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenaje`)
};

const fr_val_storage = /** @type {(inputs: Val_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangement`)
};

const de_val_storage = /** @type {(inputs: Val_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufbewahrung`)
};

const ja_val_storage = /** @type {(inputs: Val_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`収納`)
};

const zh_val_storage = /** @type {(inputs: Val_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收纳/储藏`)
};

const ar_val_storage = /** @type {(inputs: Val_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تخزين`)
};

const id_val_storage = /** @type {(inputs: Val_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyimpanan`)
};

const it_val_storage = /** @type {(inputs: Val_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviazione`)
};

const ru_val_storage = /** @type {(inputs: Val_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранение`)
};

const pt_val_storage = /** @type {(inputs: Val_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armazenamento`)
};

const ko_val_storage = /** @type {(inputs: Val_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수납장`)
};

/**
* | output |
* | --- |
* | "Storage" |
*
* @param {Val_StorageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_storage = /** @type {((inputs?: Val_StorageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_StorageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_storage(inputs)
	if (locale === "es") return es_val_storage(inputs)
	if (locale === "fr") return fr_val_storage(inputs)
	if (locale === "de") return de_val_storage(inputs)
	if (locale === "ja") return ja_val_storage(inputs)
	if (locale === "zh") return zh_val_storage(inputs)
	if (locale === "ar") return ar_val_storage(inputs)
	if (locale === "id") return id_val_storage(inputs)
	if (locale === "it") return it_val_storage(inputs)
	if (locale === "ru") return ru_val_storage(inputs)
	if (locale === "pt") return pt_val_storage(inputs)
	return ko_val_storage(inputs)
});